import { createRouter, createWebHistory } from 'vue-router';

// 基础路径配置
const baseConfig = {
  titleSuffix: ' - 中和能电力设备河北有限公司官网',
};

// 路由懒加载函数
const lazyLoad = (path) => () => import(/* webpackChunkName: "[request]" */ `@/views/${path}.vue`);

// 路由配置
const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: lazyLoad('home/Home'),
    meta: {
      title: `中和能电力设备河北有限公司官网${baseConfig.titleSuffix}`,
      keywords: "中和能电力设备河北有限公司、中和能、电力设备、河北有限公司",
      description: "中和能电力设备河北有限公司销售各种电子仪器仪表",
      prefetch: true,
      requiresAuth: false
    },
  },
    // 登录注册相关路由
    {
      path: '/login',
      name: 'LoginPage',
      component: lazyLoad('login/Login'),
      meta: { title: `登录${baseConfig.titleSuffix}` ,requiresAuth: false},
    },
  {
    path: '/about',
    name: 'AboutPage',
    component: lazyLoad('about/About'),
    meta: { title: `关于我们${baseConfig.titleSuffix}`,requiresAuth: false },
  },
  {
    path: '/link',
    name: 'LinkPage',
    component: lazyLoad('link/Link'),
    meta: { title: `联系我们${baseConfig.titleSuffix}` ,requiresAuth: false},
  },
  // 新闻相关路由
  {
    path: '/news',
    redirect: '/news/company',
    children: [
      {
        path: 'company',
        name: 'CompanyNewsPage',
        component: lazyLoad('news/CompanyNews'),
        meta: { title: `公司新闻${baseConfig.titleSuffix}`,requiresAuth: false },
      },
      {
        path: 'industry',
        name: 'IndustryNewsPage',
        component: lazyLoad('news/IndustryNews'),
        meta: { title: `行业动态${baseConfig.titleSuffix}` ,requiresAuth: false},
      },
      {
        path: 'detail',
        name: 'ArticleDetailPage',
        component: lazyLoad('news/ArticleDetail'),
        meta: { title: `新闻详情${baseConfig.titleSuffix}`,requiresAuth: false },
      },
    ],
  },
  // 产品相关路由
  {
    path: '/product',
    redirect: '/product/list',
    children: [
      {
        path: 'list',
        name: 'ProductsListPage',
        component: lazyLoad('product/ProductsList'),
        meta: { title: `产品列表${baseConfig.titleSuffix}`,requiresAuth: false },
      },
      {
        path: 'new',
        name: 'ProductNewPage',
        component: lazyLoad('product/ProductNew'),
        meta: { title: `新品展示${baseConfig.titleSuffix}`,requiresAuth: false },
      },
      {
        path: 'select',
        name: 'ProductSelectPage',
        component: lazyLoad('product/ProductSelect'),
        meta: { title: `场景选购${baseConfig.titleSuffix}`,requiresAuth: false },
      },
      {
        path: 'detail',
        name: 'ProductDetailPage',
        component: lazyLoad('product/ProductDetail'),
        meta: { title: `产品详情${baseConfig.titleSuffix}` ,requiresAuth: false},
      },
      {
        path: 'download',
        name: 'ProductDownloadPage',
        component: lazyLoad('product/ProductDownload'),
        meta: { title: `说明书下载${baseConfig.titleSuffix}`,requiresAuth: false },
      },
      {
        path: 'result',
        name: 'SearchResultPage',
        component: lazyLoad('product/SearchResult'),
        meta: { title: `搜索结果${baseConfig.titleSuffix}`,requiresAuth: false },
      },
    ],
  },
  // 服务相关路由
  {
    path: '/service',
    redirect: '/service/message',
    children: [
      {
        path: 'message',
        name: 'ServiceMessagePage',
        component: lazyLoad('service/ServiceMessage'),
        meta: { title: `在线留言${baseConfig.titleSuffix}` ,requiresAuth: false},
      },
      {
        path: 'download',
        name: 'ServiceDownloadPage',
        component: lazyLoad('service/ServiceDownload'),
        meta: { title: `资料下载${baseConfig.titleSuffix}` ,requiresAuth: false},
      },
      {
        path: 'aftersale',
        name: 'ServiceAftersalePage',
        component: lazyLoad('service/ServiceAftersale'),
        meta: { title: `售后服务${baseConfig.titleSuffix}`,requiresAuth: false },
      },
    ],
  },

  {
    path: '/register',
    name: 'RegisterPage',
    component: lazyLoad('login/Register'),
    meta: { title: `注册${baseConfig.titleSuffix}`,requiresAuth: false },
  },
  {
    path: '/agreement',
    name: 'userservieAgreementPage',
    component: lazyLoad('components/content/userserviceAgreement'),
    meta: { title: `服务协议${baseConfig.titleSuffix}`,requiresAuth: false },
  },
  {
    path: '/password_find',
    name: 'PasswordFindPage',
    component: lazyLoad('login/passwordFind'),
    meta: { title: `找回密码${baseConfig.titleSuffix}`,requiresAuth: false },
  },
  {
    path: '/password_find_to',
    name: 'PasswordFindPage2',
    component: lazyLoad('login/passwordFind2'),
    meta: { title: `找回密码${baseConfig.titleSuffix}`,requiresAuth: false },
  },
  {
    path: '/password_find_new',
    name: 'PasswordFindPage3',
    component: lazyLoad('login/passwordFind3'),
    meta: { title: `找回密码${baseConfig.titleSuffix}` ,requiresAuth: false},
  },
  {
    path: '/password_find_success',
    name: 'PasswordFindPage4',
    component: lazyLoad('login/passwordFind4'),
    meta: { title: `找回密码${baseConfig.titleSuffix}`,requiresAuth: false },
  },
  // 用户中心相关路由
  {
    path: '/user/',
    name: 'UserHomePage',
    component:lazyLoad('user/index'),
    children: [
      {
        path: 'mall',
        name: 'MallPage',
        component: lazyLoad('user/components/mall/Mall'),
        meta: { title: `我的商城${baseConfig.titleSuffix}`, requiresAuth: true },
      },
      {
        path: 'list_bought',
        name: 'ListBoughtPage',
        component: lazyLoad('user/components/order/ListBought'),
        meta: { title: `订单中心${baseConfig.titleSuffix}`, requiresAuth: true },
        children: [
          {
            path: '?smid=3-1&smtitle=订单中心&tabcode=all',
            name: 'all',
            component: lazyLoad('user/components/order/components/all'),
            meta: { title: `全部订单${baseConfig.titleSuffix}`, requiresAuth: true },
          },
          {
            path: '?smid=3-1&smtitle=订单中心&tabcode=waitpay',
            name: 'waitpay',
            component: lazyLoad('user/components/order/components/waitpay'),
            meta: { title: `待付款订单${baseConfig.titleSuffix}`, requiresAuth: true },
          },
          {
            path: '?smid=3-1&smtitle=订单中心&tabcode=waitsend',
            name: 'waitsend',
            component: lazyLoad('user/components/order/components/waitsend'),
            meta: { title: `待发货订单${baseConfig.titleSuffix}`, requiresAuth: true },
          },
          {
            path: '?smid=3-1&smtitle=订单中心&tabcode=waitconfirm',
            name: 'waitconfirm',
            component: lazyLoad('user/components/order/components/waitconfirm'),
            meta: { title: `待收货订单${baseConfig.titleSuffix}`, requiresAuth: true },
          },
        ],
      },
      {
        path: 'address',
        name: 'AdressPage',
        component: lazyLoad('user/components/address/Address'),
        meta: { title: `我的地址${baseConfig.titleSuffix}`, requiresAuth: true },
      },
      {
        path: 'aftersales',
        name: 'AfterSalesPage',
        component: lazyLoad('user/components/aftersales/AfterSales'),
        meta: { title: `我的售后${baseConfig.titleSuffix}`, requiresAuth: true },
        children: [
          {
            path: '?smid=4-1&smtitle=售后服务&type=list',
            name: 'aftersalesList',
            component: lazyLoad('user/components/aftersales/aftersalesList'),
            meta: { title: `售后服务${baseConfig.titleSuffix}`, requiresAuth: true },
          },
          {
            path: 'refundOnly',
            name: 'refundOnly',
            component: lazyLoad('user/components/aftersales/refundOnly'),
            meta: { title: `退款-售后服务${baseConfig.titleSuffix}`, requiresAuth: true },
          },
          {
            path: 'returnAndRefund',
            name: 'returnAndRefund',
            component: lazyLoad('user/components/aftersales/returnAndRefund'),
            meta: { title: `退货退款-售后服务${baseConfig.titleSuffix}`, requiresAuth: true },
          },
          {
            path: '?smid=4-1&smtitle=售后服务&type=fail',
            name: 'afterFailPage',
            component: lazyLoad('user/components/aftersales/afterFail'),
            meta: { title: `售后失败-售后服务${baseConfig.titleSuffix}`, requiresAuth: true },
          },
        ],
      },
      {
        path: 'baseinfos',
        name: 'BaseInfosPage',
        component: lazyLoad('user/components/baseinfos/BaseInfos'),
        meta: { title: `我的信息${baseConfig.titleSuffix}`, requiresAuth: true },
      },
      {
        path: 'editpassword',
        name: 'EditpasswordPage',
        component: lazyLoad('user/components/baseinfos/EditPassword'),
        meta: { title: `修改密码${baseConfig.titleSuffix}`, requiresAuth: true },
      },
    ],
  },
  {
    path: '/user/cart',
    name: 'CartPage',
    component: lazyLoad('user/components/cart/Cart'),
    meta: { title: `我的购物车${baseConfig.titleSuffix}`, requiresAuth: true },
  },
  {
    path: '/user/comfirm_order',
    name: 'comfirmOrderPage',
    component: lazyLoad('user/components/cart/confirm_order'),
    meta: { title: `结算中心${baseConfig.titleSuffix}`, requiresAuth: true },
  },
  {
    path: '/user/order/payselect',
    name: 'paySelect',
    component: lazyLoad('user/components/order/pay/paySelect'),
    meta: { title: `结算中心${baseConfig.titleSuffix}`, requiresAuth: true },
  },
  {
    path: '/user/order/orderdetail',
    name: 'orderDetail',
    component: lazyLoad('user/components/order/orderDetail'),
    meta: { title: `订单详情${baseConfig.titleSuffix}`, requiresAuth: true },
  },
  {
    path: '/user/pay/payresult',
    name: 'payResult',
    component: lazyLoad('user/components/order/pay/payResult'),
    meta: { title: `支付结果${baseConfig.titleSuffix}` ,requiresAuth: false},
  },
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  let isLoggedIn = localStorage.getItem('token');
  const requiresAuth = to.meta.requiresAuth;
  console.log(isLoggedIn)
  console.log(requiresAuth)
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  //next();
  if (requiresAuth && !isLoggedIn) {
    next('/login');
    console.log(to.fullPath)
    localStorage.setItem('redirectUrl', to.fullPath);
    
  } else {
    console.log('no requiresAuth')
    next();
  }
});

router.beforeResolve((to, from, next) => {
  console.log('进入 beforeResolve 守卫', to.path);
  next();
});

export default router;